export class EventOrderModel {
	constructor() {
		this.initOrder();
	}

	initOrder() {
		this.id = null;
		this.amount = 0;
		this.carts = [];
		this.serviceCarts = [];
	}

	getOrderData() {
		return {
			id: this.id,
			amount: this.amount,
			carts: this.carts,
			service_carts: this.serviceCarts,
		};
	}

	/**
	 * Загружает и валидирует (навзвания свойств, список билетов, сумму)
	 * Если передать id мерпориятия то будет сортировать под конкретное мероприятие! т.к в заказе могут быть несколько мероприятии
	 * @param order {Object} - Объект заказа полученный из сервера
	 * {
	 *   id,
	 *   carts {Array} - [{ event_id, ... }, ... ]
	 * }
	 * @param eventId
	 *
	 * @return {Object}
	 */
	validateOrderData(order, eventId) {
		if (!Array.isArray(order.carts)) throw new Error("Не удалось валидировать данные билетов!");

		this.id = order.id;
		this.carts = eventId ? order.carts.filter(cart => cart.event_id === eventId) : order.carts;
		this.serviceCarts = Array.isArray(order.service_carts) ? order.service_carts : [];
		this.amount = this.updateOrderAmount();

		return this.getOrderData();
	}

	updateOrderAmount(amount) {
		if (amount) return (this.amount = amount);

		this.amount = 0;
		$.each(this.carts, (i, cart) => {
			this.amount += cart.price;
		});
		/* Доп. услуги входят в сумму заказа */
		$.each(this.serviceCarts, (i, cart) => {
			this.amount += cart.price;
		});

		return this.amount;
	}

	addActiveCarts(carts) {
		$.each(carts, (i, cart) => this.carts.push(cart));

		return this.updateOrderAmount();
	}

	removeActiveCarts(carts) {
		$.each(carts, (i, cart) => {
			this.carts = this.carts.filter(el => el.uid !== cart.uid);
		});

		return this.updateOrderAmount();
	}
}
